const prepareSvgTemplate = (svgTemplate: string, params: Map<string, string>) => {
  let content = svgTemplate;
  params.forEach((value, key) => {
    content = content.replaceAll('#' + key + '#', value);
  });

  return `<svg xmlns="http://www.w3.org/2000/svg">${content}</svg>`;
};

export { prepareSvgTemplate };
